// extracted by mini-css-extract-plugin
export default {"input":"idk-field_input__W6A52","inpInner":"idk-field_inpInner__sjLGi"};